import { UploadTexts } from '../../../language/Texts';
import { GeneralAttributes } from '../../../models/GeneralAttributes';
import { RequestPaths } from '../../../models/RequestPaths';
import BoxComponent from '../../BoxComponent/BoxComponent';

const ConexoUploadAri = ({ manufacturer, setConexoResponse, setLoading, loading }) => {
    const url = RequestPaths.saveInConexoPathAri

    return (
        <>
            {manufacturer === GeneralAttributes.ari &&
                <BoxComponent
                    boxTitle={UploadTexts.qrCodeScannenAri}
                    setConexoResponse={setConexoResponse}
                    inputType='url'
                    placeholder={UploadTexts.inputIdLink}
                    buttonTex={UploadTexts.saveInConexo}
                    setLoading={setLoading}
                    loading={loading}
                    requestUrl={url}
                />
            }
        </>
    )
}

export default ConexoUploadAri